/* 1-melisa.js — slider for "1 - 01 Slider" (no dependencies) */
(function () {
  if (window.MG1) { window.MG1.init(); return; }

  function initSlider(root) {
    if (root.dataset.mg1Ready) return;
    root.dataset.mg1Ready = '1';
    var track = root.querySelector('.mg1-slider__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.mg1-slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.mg1-slider__dot'));
    var current = root.querySelector('[data-mg1-current]');
    if (!track || slides.length < 2) return;
    var index = 0, timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10);

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function paint(i) {
      index = i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (current) current.textContent = pad(i + 1);
    }
    function go(i) {
      var n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' });
      paint(n);
    }
    function start() { if (delay > 0 && !timer) timer = setInterval(function () { go(index + 1); }, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var n = Math.round(track.scrollLeft / track.clientWidth);
        if (n !== index && slides[n]) paint(n);
      });
    }, { passive: true });

    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    var prev = root.querySelector('.mg1-slider__arrow--prev');
    var next = root.querySelector('.mg1-slider__arrow--next');
    if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(index + 1); });
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) { root.addEventListener(e, stop, { passive: true }); });
    root.addEventListener('mouseleave', start);

    root.mg1Go = function (i) { stop(); go(i); };
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  /* Ürün kartı: hover → 2. görsel + oklar; oklar / küçük resimler ile görsel gezme */
  var isTouch = window.matchMedia('(hover: none)').matches;
  function initCard(card) {
    if (card.dataset.mg1Card) return;
    card.dataset.mg1Card = '1';
    var media = card.querySelector('.mg1-card__media');
    var main = card.querySelector('img.mg1-card__img');
    if (!media || !main) return;
    var list = (media.getAttribute('data-mg1-media') || '').split('|').filter(Boolean);
    if (list.length < 2) return;
    var thumbs = card.querySelectorAll('.mg1-card__thumb');
    var dots = card.querySelectorAll('.mg1-card__dots span');
    var orig = { src: main.getAttribute('src'), srcset: main.getAttribute('srcset') };
    var index = 0;

    function show(i) {
      index = (i + list.length) % list.length;
      if (index === 0) {
        if (orig.srcset) main.setAttribute('srcset', orig.srcset);
        main.src = orig.src;
      } else {
        main.removeAttribute('srcset');
        main.src = list[index];
      }
      main.classList.remove('is-switching'); void main.offsetWidth; main.classList.add('is-switching');
      Array.prototype.forEach.call(thumbs, function (x, k) { x.classList.toggle('is-on', k === index); });
      Array.prototype.forEach.call(dots, function (x, k) { x.classList.toggle('is-on', k === index); });
      card.classList.toggle('is-browsing', index !== 0);
    }
    function reset() { if (index !== 0) show(0); card.classList.remove('is-browsing'); }

    Array.prototype.forEach.call(card.querySelectorAll('.mg1-card__arrow'), function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        show(index + parseInt(btn.getAttribute('data-mg1-dir') || '1', 10));
      });
    });
    Array.prototype.forEach.call(thumbs, function (th, k) {
      th.addEventListener('mouseenter', function () { show(k); });
      th.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(k); });
    });

    if (!isTouch) {
      var hoverOn = card.hasAttribute('data-mg1-hover');
      card.addEventListener('mouseenter', function () {
        if (hoverOn && index === 0) show(1);
        card.classList.add('is-browsing');
      });
      card.addEventListener('mouseleave', reset);
    } else {
      /* Telefon: oklar gizli; görsele ilk dokunuşta 2. görsel + oklar açılır, ikinci dokunuş ürüne gider */
      var armed = false;
      media.addEventListener('click', function (e) {
        if (e.target.closest('.mg1-card__arrow')) return;
        if (!armed) {
          e.preventDefault();
          armed = true;
          if (card.hasAttribute('data-mg1-hover')) show(1);
          card.classList.add('is-browsing');
        }
      });
      document.addEventListener('touchstart', function (e) {
        if (armed && !card.contains(e.target)) { armed = false; reset(); }
      }, { passive: true });
    }
  }

  window.MG1 = {
    init: function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-mg1-slider]'), initSlider);
      Array.prototype.forEach.call(document.querySelectorAll('.mg1-card'), initCard);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.MG1.init);
  else window.MG1.init();

  /* Tema editörü */
  document.addEventListener('shopify:section:load', window.MG1.init);
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('.mg1-slide');
    if (!slide) return;
    var root = slide.closest('[data-mg1-slider]');
    var all = Array.prototype.slice.call(root.querySelectorAll('.mg1-slide'));
    if (root.mg1Go) root.mg1Go(all.indexOf(slide));
  });
})();